import { BaseModel } from "./base";

export class Estado extends BaseModel {
  constructor(public id: number, public nome: string) {
    super(id);
  }
}
